module.exports = __webpack_public_path__ + "img/logo_alt.e9f2578f.png";